import { Matcher } from '../../logical/matcher.js';
export const groupByMatcher = new Matcher();
//# sourceMappingURL=matcher.js.map